import loadable from '@loadable/component';

export const ViewOrgPageLoadable = loadable(() => import('./ViewOrgPage'), {
  resolveComponent: (module) => module.ViewOrgPage,
});
